// from https://vuefire.vuejs.org/vuefire/getting-started.html#installation

import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'

/* eslint-disable no-unused-vars */
let fb;
/* eslint-enable no-unused-vars */

export const firebaseConfig = {
    apiKey: 'AIzaSyAmwb1xL8360FSa2VeoDOvdenUXkgNzXOE',
    projectId: 'aibase',
    storageBucket: 'gs://aibase.appspot.com/'
}

// let firebaseConfig = {
//     apiKey: 'xxxxxyDLCJnu-VGWAR91i4TPff1FUg1Tl6z2oiI',
//     projectId: 'aiplanet',
//     storageBucket: 'gs://aiplanet.appspot.com/'
// }

// Get a Firestore instance
export default fb = firebase.initializeApp(firebaseConfig);

// Get a reference to the storage service, which is used to create references in your storage bucket
// export let storage = firebase.storage();

// // Export types that exists in Firestore
// // This is not always necessary, but it's used in other examples
// const { TimeStamp, GeoPoint } = firebase.firestore
// export { TimeStamp, GeoPoint }

// // if using Firebase JS SDK < 5.8.0
// db.settings({ timestampsInSnapshots: true })